<template>
	<!-- 空行删除 -->
    <el-container>
		<div class="edit-text">
			<editor v-model="textarea2"
			    @init="editorInit"
			    :options="{wrap: true}"
			    lang="text"
				:theme="editorTheme"
			    width="100%"
			    height="100%">
			</editor>
		</div>
        <div style="margin: 15px 0px;">
            <el-button-group>
                <el-button type="primary" @click="humpToSpace">删除空行</el-button>
            </el-button-group>
        </div>
		<div class="edit-text">
			<editor v-model="resultText"
			    @init="editorInit"
			    :options="{wrap: true}"
			    lang="text"
				:theme="editorTheme"
			    width="100%"
			    height="100%">
			</editor>
		</div>
    </el-container>
</template>

<script>
export default {
    name: "g-textTool",
    data() {
        return {
            textarea2:"",
			resultText:'',
        };
    },
	components: {
		editor: require('vue2-ace-editor'),
	},
    methods: {
        humpToSpace(){
			this.resultText = this.textarea2.replace(/\n\s*\r/ig, '').replace(/^(\s*)$\n/ig, '');
        },
	},
    mounted() {
        
    },
};
</script>
<style lang="scss" scoped>
	.el-container /deep/{
		flex-flow: column;
		display: flex;
		
		.edit-text{
			flex: 1;
			display: flex;
			border: 1px solid #DCDFE6;
			border-radius: 3px;
			overflow: hidden;
		}
	}
</style>
